import { createSelector } from "reselect";

const selectCurrectReq = (state) => state.currentReq;

export const selectCurrentReqInfo = createSelector(
  selectCurrectReq,
  (currentReq) => (currentReq.info ? currentReq.info : "")
);

export const selectCurrentReqIsLoading = createSelector(
  selectCurrectReq,
  (currentReq) => currentReq.isLoading
);

export const selectCurrentReqBits = createSelector(
  selectCurrectReq,
  (currentReq) => (currentReq.bits ? currentReq.bits : [])
);

export const selectCurrentReqBitsIsLoading = createSelector(
  selectCurrectReq,
  (currentReq) => currentReq.bitsIsLoading
);

export const selectCurrentReqLoadLocation = createSelector(
  selectCurrectReq,
  (currentReq) => (currentReq.loadLocation ? currentReq.loadLocation : "")
);
